export const takeBannerImages = data => {
  if (!data?.enabled) return [];

  return data?.images.map((el, index) => ({
    image: el?.url,
    mobileImage: data.responsive_image[index]?.url,
    altText: el?.originalName,
    key: el?.id,
    href: data?.redirection_link[index] ? data.redirection_link[index] : undefined,
  }));
};

export const setSideBanner = (banner, variable = 'image') => {
  if (!banner?.enabled) return undefined;
  const currentDate = new Date();
  let targetDate = new Date(banner?.end_date);
  let startDate = new Date(banner?.start_date);

  if (currentDate < targetDate && currentDate >= startDate) {
    if (variable === 'image') return banner?.image?.url;
    else if (variable === 'link') return banner?.redirection_link;
    else return banner?.image?.url;
  }
};
